/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { SearchSheetRowHierarchyRequestNumberColumnDataFromJSON, SearchSheetRowHierarchyRequestNumberColumnDataToJSON, SearchSheetRowHierarchyRequestWithDataChildrenFromJSON, SearchSheetRowHierarchyRequestWithDataChildrenToJSON, } from './';
export function SearchSheetRowHierarchyRequestFromJSON(json) {
    return SearchSheetRowHierarchyRequestFromJSONTyped(json, false);
}
export function SearchSheetRowHierarchyRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        path: json['path'],
        withDataChildren: !exists(json, 'withDataChildren')
            ? undefined
            : json['withDataChildren'].map(SearchSheetRowHierarchyRequestWithDataChildrenFromJSON),
        numberColumnsData: !exists(json, 'numberColumnsData')
            ? undefined
            : json['numberColumnsData'].map(SearchSheetRowHierarchyRequestNumberColumnDataFromJSON),
        withDataCompoundExpression: !exists(json, 'withDataCompoundExpression')
            ? undefined
            : json['withDataCompoundExpression'],
        filterCompoundExpression: !exists(json, 'filterCompoundExpression')
            ? undefined
            : json['filterCompoundExpression'],
    };
}
export function SearchSheetRowHierarchyRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        path: value.path,
        withDataChildren: value.withDataChildren === undefined
            ? undefined
            : value.withDataChildren.map(SearchSheetRowHierarchyRequestWithDataChildrenToJSON),
        numberColumnsData: value.numberColumnsData === undefined
            ? undefined
            : value.numberColumnsData.map(SearchSheetRowHierarchyRequestNumberColumnDataToJSON),
        withDataCompoundExpression: value.withDataCompoundExpression,
        filterCompoundExpression: value.filterCompoundExpression,
    };
}
